import axios from '../javascript/custom-axios'
const RESOURCE_NAME = 'badge'

export default {
  getBadges(page=1,pageSize=100,badgeType) {
    return axios.get(`${RESOURCE_NAME}/getAllBadges`, { params: { page: page, pageSize:pageSize,badgeType:badgeType } })
  },
  getBadgeById(id) {
    return axios.get(`${RESOURCE_NAME}/getBadgeById`, { params: { Id:id } })
  },
  deleteBadge(id){
    return axios.put(`${RESOURCE_NAME}/deleteById/${id}`)
 
  },
  createBadge(body){
    return axios.post(`${RESOURCE_NAME}/createBadge`,body)
 
  },
  updateBadge(body){
    return axios.put(`${RESOURCE_NAME}/updateBadge`,body)
 
  },
  finishInnovation(id){
    return axios.put(`${RESOURCE_NAME}/giveScoretoUser/${id}`)
 
  },
}